import { API_ENDPOINTS } from '@/constants/api';
import { api } from '@/shared/api';
import type { ProductOption, ReplacementBatch, ReplacementBatchFormData } from '../types';

export const replacementBatchesApi = {
  getList: async (params?: { perPage?: number; page?: number }) => {
    const response = await api.get<{
      data: ReplacementBatch[];
      currentPage: number;
      perPage: number;
      total: number;
      lastPage: number;
    }>(API_ENDPOINTS.REPLACEMENT_BATCHES.LIST, { params });
    return response.data;
  },

  getOne: async (id: number) => {
    const response = await api.get<{ data: ReplacementBatch }>(
      API_ENDPOINTS.REPLACEMENT_BATCHES.SHOW(id.toString()),
    );
    return response.data.data;
  },

  create: async (data: ReplacementBatchFormData) => {
    const response = await api.post<{ data: ReplacementBatch }>(
      API_ENDPOINTS.REPLACEMENT_BATCHES.CREATE,
      data,
    );
    return response.data.data;
  },

  getProducts: async () => {
    const response = await api.get<{ data: ProductOption[] }>(
      API_ENDPOINTS.REPLACEMENT_BATCHES.PRODUCTS,
    );
    // Backend returns { data: ProductOption[] }, axios wraps it in response.data
    // So response.data is { data: ProductOption[] }, we need response.data.data
    return response.data.data || [];
  },

  update: async (id: number, data: Partial<ReplacementBatchFormData>) => {
    const response = await api.put<{ data: ReplacementBatch }>(
      API_ENDPOINTS.REPLACEMENT_BATCHES.UPDATE(id.toString()),
      data,
    );
    return response.data.data;
  },

  delete: async (id: number) => {
    await api.delete(API_ENDPOINTS.REPLACEMENT_BATCHES.DELETE(id.toString()));
  },
};
